import { createContext, useContext } from "react";

export const MenuContext = createContext({
  toggleMenu: () => {},
  menuOpen: false,
});

export const useMenu = () => useContext(MenuContext);
